
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/125w-bifacial-modular-solar-panel",
      function () {
        return require("private-next-pages/125w-bifacial-modular-solar-panel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/125w-bifacial-modular-solar-panel"])
      });
    }
  